var map = {
	"./amazon-icon.png": 396,
	"./blog-icon.png": 1712,
	"./facebook-ad-icon.png": 8352,
	"./news-icon.png": 4379,
	"./product-description-icon.png": 5214,
	"./tiktok-icon.png": 2858,
	"./weekly-report-icon.png": 7150,
	"./weibo-icon.png": 4002,
	"./xiaohongshu-icon.png": 943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;